<div class="p-5 text-center rounded animated fadeInUp" [ngClass]="{ 'blue-grey lighten-5': opaque, 'app-empty-frame': !opaque }">
  <img *ngIf="!action" src="./assets/images/empty.svg" class="animated rotateIn app-empty-shadow">
  <img *ngIf="action" src="./assets/images/empty_begin.svg" class="animated rotateIn app-empty-shadow">
  <h5 class="py-3 m-0" [ngClass]="{ 'blue-grey-text': opaque, 'white-text': !opaque }">
    {{ (action ? actionDescription : description) | translate }}
  </h5>
  <button *ngIf="action" (click)="onAction()" type="button" mdbBtn [color]="color" class="m-0 z-depth-0" mdbWavesEffect>
    <i class="far {{actionIcon}} mr-1"></i>{{ actionText | translate }}
  </button>
</div>